import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";
import { getDummyText } from "../../utils";

export default {
    title: "Components/Teaser Product Tile",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    component: "ux-iws-teaser-product-tile",
    args: {
        eyecatcher: "Eyecatcher",
        linkText: "Zum Produkt",
        linkUrl: "#",
        productDesc: "Product Description " + getDummyText(100),
        productImageUrl: "mock-assets/images/trulaser-station-7000.jpg",
        productName: "TruLaser Station 7000",
    },
    argTypes: {
        eyecatcher: {
            control: "string",
        },
        linkText: {
            control: "string",
        },
        linkUrl: {
            control: "string",
        },
        productDesc: {
            control: "string",
        },
        productImageUrl: {
            control: "string",
        },
        productName: {
            control: "string",
        },
    },
};

const Template = ({
    eyecatcher,
    linkText,
    linkUrl,
    productDesc,
    productImageUrl,
    productName,
}) =>
    html`<ux-iws-teaser-product-tile
        eyecatcher="${eyecatcher}"
        link-text="${linkText}"
        link-url="${linkUrl}"
        product-desc="${productDesc}"
        product-image-url="${productImageUrl}"
        product-name="${productName}"
    ></ux-iws-teaser-product-tile>`;

export const Default = Template.bind({});
